import { message } from "antd";
import "react-toastify/dist/ReactToastify.css";

export const copytoClipBoard = (param, t) => {
  navigator.clipboard.writeText(param).then(
    () => {
      message.success(t("copied"));
    },
    (err) => {
      console.error("Async: Could not copy text: ", err);
    }
  );
};
